import { useCallback, useRef } from 'react';

type CallbackFunction = (...args: unknown[]) => unknown;

export const useDebounce = () => {
    const timer = useRef<NodeJS.Timeout>();

    const debounce = useCallback(
        <F extends CallbackFunction>(fn: F, delay: number) => {
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                fn();
            }, delay);
        },
        []
    );

    return debounce;
};
